<div class="container-fluid p-0" class="p-4">
  <div class="h5">
    Units
  </div>
  <button type="button" class="close" aria-label="Close"  (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>

  <div class="row">
    <dx-data-grid
      [rowAlternationEnabled]="true"
      [hoverStateEnabled]="true"
      [cellHintEnabled]="false"
      [columnAutoWidth]="true"
      [dataSource]="dataSource">
      <dxo-editing
        mode="cell"
        [refreshMode]="'full'"
        [allowAdding]="canEdit()"
        [allowUpdating]="canEdit()"
        [allowDeleting]="canEdit()"
      >
      </dxo-editing>
      <dxi-column caption="Name" dataField="name">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-column>

      <dxo-paging [pageSize]="12"></dxo-paging>
    </dx-data-grid>
  </div>
</div>
